export type CognitoRuntimeConfig = {
  userPoolId: string;
  clientId: string;
  cognitoDomain: string;
};

let configuredConfig: CognitoRuntimeConfig | null = null;

export function setCognitoRuntimeConfig(
  config: CognitoRuntimeConfig | null | undefined,
): void {
  if (
    !config?.userPoolId?.trim() ||
    !config?.clientId?.trim() ||
    !config?.cognitoDomain?.trim()
  ) {
    configuredConfig = null;
    return;
  }

  configuredConfig = {
    userPoolId: config.userPoolId.trim(),
    clientId: config.clientId.trim(),
    cognitoDomain: config.cognitoDomain.trim(),
  };
}

export function getCognitoRuntimeConfig(): CognitoRuntimeConfig | null {
  return configuredConfig;
}

export function getConfiguredUserPoolId(): string | null {
  return configuredConfig?.userPoolId ?? null;
}

/** @deprecated Prefer `setCognitoRuntimeConfig` with the full Cognito client config. */
export function setConfiguredUserPoolId(userPoolId: string | null | undefined): void {
  const trimmed = userPoolId?.trim();
  if (!trimmed) {
    configuredConfig = null;
    return;
  }
  if (configuredConfig) {
    configuredConfig = { ...configuredConfig, userPoolId: trimmed };
    return;
  }
  configuredConfig = {
    userPoolId: trimmed,
    clientId: "",
    cognitoDomain: "",
  };
}

export function clearConfiguredUserPoolId(): void {
  configuredConfig = null;
}
